const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:8787';

export interface WhatsAppLeadItem {
  productId: string;
  name: string;
  size: string;
  quantity: number;
  price: number;
}

function fire(path: string, body: unknown): void {
  fetch(`${BASE}${path}`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(body),
  }).catch(() => {});
}

export function trackPageView(pagePath: string): void {
  fire('/api/v1/analytics/view', { path: pagePath });
}

export function trackWhatsAppLead(opts: {
  customerName: string;
  items: WhatsAppLeadItem[];
  totalAmount: number;
  deliveryType: 'envio' | 'retiro';
}): void {
  fire('/api/v1/analytics/whatsapp-lead', opts);
}
